import React from 'react'
import styled from 'styled-components'

import {DATE_FORMAT} from '../../config/DateFormat'
import {strToDate} from '../../utils/utils'
import {formatNoUTCDate} from '../../utils'

export const StudyCard = styled(({study, className, patientLabel, showRefPhysican}) => {

  const studyDate = strToDate(study.study.studyDate)
  const formattedStudyDate = isNaN(studyDate.getTime()) ? "" : formatNoUTCDate(studyDate,DATE_FORMAT())

  return <div className={className}>
    <div className="study-info notranslate">{patientLabel && "Patient: "}{study.patient.patientName}</div>
    <div className="study-info notranslate"><b>Study:</b> {study.study.modalities} - {study.study.studyDescription} <span className="nowrap">({formattedStudyDate})</span></div>
    {showRefPhysican && study.physician && <div className="study-info notranslate"><b>Referring physician:</b> {study.physician}</div>}
  </div>
})`
  border-radius: 6px;
  border: 1px solid rgba(0,0,0,0.25);
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  .study-info {
    color: rgba(0,0,0,0.7);
    margin-top: 2px;
    :first-child {
      font-size: 14px;
      font-weight: 600;
      color: inherit;
      margin-top: 0;
    }
  }
  & ~ & {
    margin-top: -1rem;
  }
`